<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricoes[index])'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                |
                | {{ restricao.year || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao?.areaTotalFeatureHa || restricao?.areaHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'prodes-cerrado-2023',

    data() {
        return {};
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>
